__turbopack_context__.v({
  "dark": "NIvM2a_dark",
  "modalRoot": "NIvM2a_modalRoot",
  "primaryOffersRoot": "NIvM2a_primaryOffersRoot",
  "transitionRoot": "NIvM2a_transitionRoot",
});
